import {
  GET_ADMIN_BENEFIT_ITEM,
  GET_ADMIN_BENEFIT_ITEM_SUCCESS,
  GET_ADMIN_BENEFIT_ITEM_ERROR,
  GET_ADMIN_BENEFIT_ITEM_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAdminBenefitItems = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_BENEFIT_ITEM:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ADMIN_BENEFIT_ITEM_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_ADMIN_BENEFIT_ITEM_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ADMIN_BENEFIT_ITEM_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAdminBenefitItems;
